/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React from 'react';
import PropTypes from 'prop-types';

import {
  BatteryAlert,
  Battery20,
  Battery30,
  Battery50,
  Battery60,
  Battery80,
  Battery90,
  BatteryFull,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import CustomTooltip from '../../atoms/CustomTooltip';

const BatteryIcon = ({ percentage, ...props }) => {
  if (percentage == null) return null;

  let Icon;

  if (percentage < 10) {
    return <BatteryAlert color="warning" />;
  } else if (percentage < 30) {
    Icon = Battery20;
  } else if (percentage < 50) {
    Icon = Battery30;
  } else if (percentage < 60) {
    Icon = Battery50;
  } else if (percentage < 80) {
    Icon = Battery60;
  } else if (percentage < 90) {
    Icon = Battery80;
  } else if (percentage < 100) {
    Icon = Battery90;
  } else {
    Icon = BatteryFull;
  }

  return <Icon {...props} />;
};

const BatteryLevel = ({ percentage, showLabel, ...props }) => {
  const label = `${Math.floor(percentage)}%`;
  return (
    <CustomTooltip title={showLabel ? '' : label}>
      <Box display="flex" alignItems="center">
        <BatteryIcon percentage={percentage} {...props} />
        {showLabel && <span>{label}</span>}
      </Box>
    </CustomTooltip>
  );
};

BatteryIcon.propTypes = {
  percentage: PropTypes.number.isRequired,
};

BatteryLevel.propTypes = {
  percentage: PropTypes.number.isRequired,
  showLabel: PropTypes.bool,
};

export default BatteryLevel;
